import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  PasswordInput,
  required,
  minLength,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  useGetList,
  useRedirect,
  useNotify,
} from 'react-admin';
import { Grid, Typography, Box } from '@mui/material';

export const UsersCreate: React.FC = () => {
  const { data: roles = [], isLoading: rolesLoading } = useGetList('roles');
  const redirect = useRedirect();
  const notify = useNotify();

  const roleChoices = roles.map((role: any) => ({
    id: role.name,
    name: role.name || role.roleName,
  }));

  const handleSuccess = (data: any) => {
    notify('Usuario creado exitosamente', { type: 'success' });
    redirect('show', 'users', data.id);
  };

  return (
    <Create
      title='Crear Nuevo Usuario'
      mutationOptions={{
        onSuccess: handleSuccess,
      }}
    >
      <SimpleForm>
        <Box sx={{ width: '100%', maxWidth: 600 }}>
          <Typography variant='h6' gutterBottom>
            Información Personal
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextInput
                source='userName'
                label='Nombre de Usuario'
                validate={[required(), minLength(3)]}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextInput
                source='email'
                label='Correo Electrónico'
                validate={[required()]}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <TextInput
                source='fullName'
                label='Nombre Completo'
                validate={[required()]}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <TextInput
                source='phoneNumber'
                label='Número de Teléfono'
                fullWidth
              />
            </Grid>
          </Grid>
          <Typography variant='h6' gutterBottom sx={{ mt: 3 }}>
            Credenciales de Acceso
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <PasswordInput
                source='password'
                label='Contraseña'
                validate={[required(), minLength(8)]}
                fullWidth
              />
            </Grid>
          </Grid>
          <Typography variant='h6' gutterBottom sx={{ mt: 3 }}>
            Roles
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ArrayInput source='roles' label='Roles asignados'>
                <SimpleFormIterator
                  disableAdd={rolesLoading}
                  disableRemove={false}
                >
                  <SelectInput
                    source=''
                    label='Seleccionar Rol'
                    choices={roleChoices}
                    validate={[required()]}
                    fullWidth
                    disabled={rolesLoading}
                    helperText='Selecciona un rol para asignar al usuario'
                  />
                </SimpleFormIterator>
              </ArrayInput>
              {rolesLoading && (
                <Typography
                  variant='body2'
                  color='text.secondary'
                  sx={{ mt: 1 }}
                >
                  Cargando roles disponibles...
                </Typography>
              )}
              {!rolesLoading && roleChoices.length === 0 && (
                <Typography variant='body2' color='warning.main' sx={{ mt: 1 }}>
                  No hay roles disponibles. Contacte al administrador.
                </Typography>
              )}
            </Grid>
          </Grid>
        </Box>
      </SimpleForm>
    </Create>
  );
};
